import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledBtn = styled.button`

    width: ${(props)=> props.size ? props.size : "100px"};
    height: ${props=> props.small? "": "48px"};

    border: none;
    border-radius: 4px;

    padding: 11px;
    background-color: ${props=> props.BGcolor ? props.BGcolor : "var(--color-grey-1)" };
    color: var(--color-grey-0);

    font-size: ${props=> props.fontSize? props.FontSize : "1rem"};
    font-weight: 500;

    :hover{
        filter: brightness(0.8);
    }
`


export const StyledLink = styled(Link)`

    width: ${(props)=> props.size ? props.size : "100px"};
    height: 48px;

    border: none;
    border-radius: 4px;

    display: flex;
    align-items: center;
    justify-content: center;

    text-align: center;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;

    transition: 0.3s ease;

    padding: 11px;
    background-color: ${props=> props.BGcolor ? props.BGcolor : "var(--color-grey-1)" };
    color: var(--color-grey-0);

    font-size: ${props=> props.fontSize? props.FontSize : "1rem"};
    font-weight: 500;

    :hover{
        filter: brightness(0.8);
    }
    
`